import React, { Component } from 'react';
import classnames from 'classnames';
import { Route, Redirect, Switch, NavLink } from 'react-router-dom';

import Users from './users/Users';
import Groups from './groups/Groups';
import Traders from './traders/Traders';
import CurrencyPairAdmin from './currencyPairs/CurrencyPair';
import Errors from '../errors/Errors';
import { getPlatformName, getPlatformDisplayName } from '../utility/platform';

import './Admin.css';
import '../platform.css';

class AdminComponent extends Component {
  render() {
    const platform = getPlatformName();
    const displayPlatform = getPlatformDisplayName();

    return (
      <div className={classnames('Admin', platform)}>
        <div className="Admin-header App-header">
          <h1><NavLink className="Admin-root" to="/">ORB</NavLink> - ADMIN{displayPlatform}</h1>
          <div className="Admin-menu">
            <NavLink to="/admin/users" className="Admin-item" activeClassName="selected">Users</NavLink>
            <NavLink to="/admin/groups" className="Admin-item" activeClassName="selected">Groups</NavLink>
            <NavLink to="/admin/traders" className="Admin-item" activeClassName="selected">Traders</NavLink>
            <NavLink to="/admin/currencypairs" className="Admin-item" activeClassName="selected">Currency Pairs</NavLink>
          </div>
        </div>
        <div className="Admin-content">
          <Switch>
            <Route path="/admin/users" component={Users} />
            <Route path="/admin/groups" component={Groups} />
            <Route path="/admin/traders" component={Traders} />
            <Route path="/admin/currencypairs" component={CurrencyPairAdmin} />
            <Redirect from="/admin" to="/admin/users" />
          </Switch>
        </div>
        <Errors />
      </div>
    );
  }
}

export default AdminComponent;



// WEBPACK FOOTER //
// ./src/admin/Admin.js